import { render, staticRenderFns } from "./TachographHistoryTable.vue?vue&type=template&id=83d71b94&scoped=true&"
import script from "./TachographHistoryTable.vue?vue&type=script&lang=js&"
export * from "./TachographHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./TachographHistoryTable.vue?vue&type=style&index=0&id=83d71b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d71b94",
  null
  
)

/* custom blocks */
import block0 from "./TachographHistoryTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports